module.exports = __webpack_public_path__ + "static/media/IMAGE_0.f877811b.png";